export default __webpack_public_path__ + "static/media/ch.30cef68e.jpg";